import { IconButton } from "@/components/form"
import { type Filter } from "@/models"
import { faSearchPlus } from "@fortawesome/free-solid-svg-icons"
import { css } from "vite-css-in-js"
import { type Reactive } from "vue"
import { defineComponent, inferProps, type ReactiveComponent } from "vue-utils"
import AdvancedFilterCard from "./AdvancedFilterCard"

interface Props {
	filters: Reactive<Filter[]>
	filterEdited(filter: Filter): void
	filterRemoved(filter: Filter): void
	createFilter(): void
}

const filterFormatting = css`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: center;
	overflow: auto;
	padding-right: 0.6rem;
	padding-bottom: 0.6rem;
	height: 0;
	flex-grow: 1;
	flex-shrink: 1;
	flex-basis: 0%;
`

const AdvancedFilters: ReactiveComponent<Props> = (props) => {
	return () => (
		<>
			<IconButton
				class="justify-content-center mb-3"
				color="success"
				icon={faSearchPlus}
				onClick={props.createFilter}
				title="Create Filter"
			>
				Add Filter
			</IconButton>
			{props.filters.length === 0 ? (
				<h3 class="d-flex align-items-center justify-content-evenly flex-grow-1">No Filters Applied</h3>
			) : (
				<div class={filterFormatting}>
					{props.filters.map((filter, i) => (
						<AdvancedFilterCard
							key={i}
							filter={filter}
							editFilter={props.filterEdited}
							removeFilter={props.filterRemoved}
						/>
					))}
				</div>
			)}
		</>
	)
}

export default defineComponent(AdvancedFilters, inferProps<Props>())
